import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum.ts";
import type { ErrorResources } from "./ErrorResources.ts";

export function defineErrorResources<T extends Record<string, string>>(resources: {
  [LanguageEnum.CS]: T;
  [LanguageEnum.EN]: { [K in keyof T]: string };
}): ErrorResources {
  return resources as ErrorResources;
}
